/* sm-clarity.js (24.10.2026, eigandi): Microsoft Clarity (hitakort og upptökur), verkefni z2ullgr9pd.
   Hleðst AÐEINS ef gestur hefur samþykkt tölfræði (Shopify Customer Privacy: analyticsProcessingAllowed),
   annaðhvort við hleðslu síðu eða þegar hann samþykkir í kökuborðanum (atburðurinn sm:kokur úr sm-kokubordi.js).
   Ef samþykki er dregið til baka: clarity('consent', false) svo Clarity hættir og eyðir kökum sínum.
   Persónuvernd: nöfn og textar viðskiptavina eru falin í upptökum (data-clarity-mask) á forskoðunum
   (lifandi teikning, hurðaskilti) og öllum innsláttarreitum, auk sjálfgefinnar felingar Clarity.
   Ekkert annað er sent; engin auglýsingakaka (ad_Storage denied). */
(function () {
  'use strict';
  var VERKEFNI = 'z2ullgr9pd';
  var hladid = false;

  function cp() { return window.Shopify && window.Shopify.customerPrivacy; }
  function leyft() {
    try { var c = cp(); return !!(c && typeof c.analyticsProcessingAllowed === 'function' && c.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }
  /* fela persónuupplýsingar í upptökum: forskoðanir og innsláttarreitir */
  var FELA = '[data-vs-svid], .vs-teikning, .vs-hurd-svid, .vs-hurd-plata, input, textarea, [contenteditable="true"], .sm-karfa-lina, [data-karfa-eiginleikar]';
  function merkja(rot) {
    try {
      var l = (rot || document).querySelectorAll(FELA);
      for (var i = 0; i < l.length; i++) if (!l[i].hasAttribute('data-clarity-mask')) l[i].setAttribute('data-clarity-mask', 'true');
    } catch (e) {}
  }
  function hlada() {
    if (hladid || !leyft()) return;
    hladid = true;
    merkja();
    try {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
          var n = m[i].addedNodes[j];
          if (n.nodeType === 1) { if (n.matches && n.matches(FELA)) n.setAttribute('data-clarity-mask', 'true'); merkja(n); }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i + '?ref=bwt';
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', VERKEFNI);
    try { window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' }); } catch (e) {}
  }
  function afturkalla() {
    if (!hladid) return;
    try { window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'denied' }); window.clarity('consent', false); } catch (e) {}
  }
  function athuga() { if (leyft()) hlada(); else afturkalla(); }

  /* val í kökuborðanum */
  document.addEventListener('sm:kokur', function (e) {
    var d = e && e.detail;
    if (d && d.analytics) { hlada(); } else { afturkalla(); }
  });
  /* samþykki sem Shopify safnar (aðrar leiðir) */
  document.addEventListener('visitorConsentCollected', athuga);

  function byrja() {
    if (cp()) return athuga();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) athuga(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', byrja); else byrja();
})();
